<template>
  <div class="body_div">
    <div class="nav">
      <div class="top">
        <div class="w clearfix">
          <div class="logo fl "  @click="setmenu(1)">
            <router-link to="" tag="a">
              <img :src="listhead.logo.url" :alt="listhead.logo.alt"/>
            </router-link>
          </div>
          <div class="menu fr">
            <ul v-show="searchs.but">
              <li v-for="programas in listhead.programas" :key="programas.id"
                  :class="nav_id == programas.id? 'active':''">
                <router-link tag="a" to="" @click.native="setmenu(programas.id)">{{programas.name}}</router-link>
              </li>
            </ul>
<!--            搜索栏-->
            <div v-show="searchs.sear" class="input_div fl">
              <img src="https://www.sjzqcrl.com/zhtypc/img/search.png" @click="search()"/>
              <input v-model="reach" @keyup.enter="search()"/>
              <img src="https://www.sjzqcrl.com/zhtypc/img/close.png" @click="search_off()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view :nav_id="nav_id"></router-view>
    <div class="footer">
      <div class="data">
        <div class="w clearfix data-link">
          <div class="fl clearfix data-fl">
            <div class="fl about-us">
              <ul>
                <li  @click="setmenufoot(7)">
                  关于我们
                </li>
                <li v-for="abouts in listfoot.abouts" :key="abouts.id" @click="setmenufoot(abouts.column_id)">
                  <router-link to="" tag="a" v-html="abouts.name"></router-link>
                </li>
              </ul>
            </div>
            <div class="fl contact-us">
              <h4>联系我们</h4>
              <div v-for="contact in listfoot.contact" :key="contact.id" class="contact-main">
                <img :src="contact.img"/>
                <span v-html="contact.content"></span>
              </div>
            </div>
            <div class="fl blogroll">
              <ul>
                <li>
                  <span>友情链接</span>
                </li>
                <li v-for="link in listfoot.link" :key="link.id">
                  <a :href="link.site" target="_Blank" rel="nofollow" v-html="link.name"></a>
                </li>
              </ul>
            </div>

          </div>
          <div class="fr clearfix data-fr center" style="margin-top: 60px;">
            <div class="fl wechat">
              <img :src="listfoot.wechat.img" alt/>
              <p v-html="listfoot.wechat.p1"></p>
              <p v-html="listfoot.wechat.p2"></p>
            </div>
<!--            <div class="chat clearfix">-->
<!--              <div class="" v-for="(item,index) in listfoot.qq" :key="index">-->
<!--                <a :href="item.href" rel="nofollow" target="_Blank">-->
<!--                  <img src="@/assets/images/qq.png" alt/>点我交谈-->
<!--                </a>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="information">
        <div class="w clearfix">
          <div class="fl information-fl">
            <p>Copyright @ 石家庄飞天科技开发有限公司 版权所有&emsp;<a :href="listfoot.information.Copyright" style="color:#fff;" rel="nofollow" target="_Blank">冀ICP备14015570号-5</a></p>
          </div>
          <div class="fr information-fr">
            <img :src="listfoot.information.mark.imgs[0].img" alt/>
            <span v-html="listfoot.information.mark.imgs[0].content"></span>
            <img :src="listfoot.information.mark.imgs[1].img" alt/>
            <span v-html="listfoot.information.mark.imgs[1].content"></span>
            <span v-html="listfoot.information.mark.mak"></span>
          </div>
        </div>
      </div>
      <div class="gotop" @click="gotop()">
        <img src="@/assets/images/gotop.png"/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        nav_id: 0,//当前选中项
        swipers: '',
        reach: "",
        listhead: {
          logo: {
            url: require("@/assets/images/logo.png"),
            alt: "石家庄飞天科技有限公司",
          },
          programas: [],
        },
        keyword: '',
        searchs: {
          but: false,
          sear: false
        },
        listfoot: {
          abouts: [
          ],
          link: [
          ],
          wechat: {
            img: require("@/assets/images/weixin.jpg"),
            p1: "石家庄飞天科技",
            p2: "微信公众平台"
          },
          contact: [
            {
              id: 1,
              img: require("@/assets/images/dh.png"),
              content: "0311-85048504 / 18395603129"
            },
            {
              id: 2,
              img: require("@/assets/images/email.png"),
              content: "sjzftkj@126.com"
            },
            {
              id: 3,
              img: require("@/assets/images/dz.png"),
              content: "石家庄市槐安西路88号卓达中苑商务大厦B座305"
            }
          ],
          qq: [
            "http://wpa.qq.com/msgrd?v=3&uin=504922487&site=qq&menu=yes",
            "http://wpa.qq.com/msgrd?v=3&uin=504922487&site=qq&menu=yes"
          ],
          information: {
            Copyright:
              "https://beian.miit.gov.cn/",
            mark: {
              imgs: [
                {
                  id: 1,
                  img: require("@/assets/images/govIcon.png"),
                  content: "工商网监"
                },
                {
                  id: 2,
                  img: require("@/assets/images/gaico.png"),
                  content: "冀公网安备"
                }
              ],
              mak: "13010802000970号"
            }
          }
        },
        setmenus:sessionStorage.getItem('setmenu')
      };
    },
    methods: {
      search_on() {
        $(".nav .menu ul").fadeOut(100);
        $(".nav .menu .input_div").fadeIn(1000);
      },
      search_off() {
        // this.searchs.but = false;
        // this.searchs.sear = true;
        $(".nav .menu ul").fadeIn(1000);
        $(".nav .menu .input_div").fadeOut(100);
      },
      search() {
        this.$router.push(
          'items'
        )
      },
      //导航栏目菜单切换
      setmenu(val) {
        // this.$store.dispatch('acmenu', val)
        // this.nav_id = this.$store.getters.getmenu;
        // sessionStorage.setItem("setmenu", val);
        if (val == 1) {
          this.$router.push('/')
        } else if (val == 2) {
          this.$router.push({
            name: 'webcase', params: {
              id: 101+'.html'
            }
          })
        } else if (val == 7) {
          this.$router.push('/about.html')
        } else {
          // console.log(val)
          this.$router.push({
            name: 'items', params: {
              id: val+'.html'
            }
          })
        }
        // console.log(this.$route.name)
        if(this.$route.name == 'index'){
          this.nav_id = 1
        }else if(this.$route.name == 'items'){
          this.nav_id = this.$route.params.id.split('.')[0]
          // console.log(this.nav_id)
        }else if(this.$route.name == 'webcase'){
          this.nav_id = 2
        }else  if(this.$route.name == 'about'){
          this.nav_id = 7
        }
      },
      setmenufoot(val) {
        if (val == 2) {
          this.$router.push({
            name: 'webcase', params: {
              id: 101+'.html'
            }
          })
        } else if (val == 7) {
          this.$router.push('/about.html')
        } else {
          this.$router.push({
            name: 'items', params: {
              id: val+'.html'
            }
          })
        }
        if(this.$route.name == 'items'){
          this.nav_id = this.$route.params.id.split('.')[0]
          // console.log(this.nav_id)
        }else if(this.$route.name == 'webcase'){
          this.nav_id = 2
        }else  if(this.$route.name == 'about'){
          this.nav_id = 7
        }
      },

      async getmenu() {
        var dt = await this.$axios.get('/api/header')
        dt.data = JSON.parse(dt.data)
        // console.log('88888')
        // console.log(dt);
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        // console.log(dt)
        this.listhead.programas = dt.data.data.programas
        this.listhead.banner = dt.data.data.banner
        this.searchs.but = true;
        this.swipers = true
      },
      async getfooter() {
        var that = this;
        var dt = await this.$axios.get('/api/footer')

        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        that.listfoot.abouts = dt.data.data.abouts
        that.listfoot.link = dt.data.data.link
        that.listfoot.qq = dt.data.data.qq
      },
      gotop() {
        $("html, body").animate({scrollTop: 0}, 800);
        return false;
      }
    },
    created() {
      if(this.$route.name == 'webcase'){
        this.nav_id = 2
      }else if(this.$route.name == 'index'){
        this.nav_id = 1
      }else if(this.$route.name == 'about'){
        this.nav_id = 7
      }else if(this.$route.name == 'items'){
        this.nav_id = this.$route.params.id.split('.')[0]
      }
      this.getfooter();

      //在线咨询
      //   var _hmt = _hmt || [];
      //   (function() {
      //     var hm = document.createElement("script");
      //   hm.src = "https://hm.baidu.com/hm.js?b2379d0f69469913897489dec1b648db";
      //     var s = document.getElementsByTagName("script")[0];
      //     s.parentNode.insertBefore(hm, s);
      //   })();
    },
    mounted() {
      //返回顶部
      $(".gotop").hide();
      $(window).bind("scroll resize", function () {
        if ($(window).scrollTop() <= 1000) {
          $(".gotop").hide();
        } else {
          $(".gotop").show();
        }
      });
      this.getmenu()
    },
    beforeUpdate() {
      // var that = this
      // $('.el-input__inner').focus(function () {
      //   that.searchs.but = false;
      //   that.searchs.sear = true;
      // }).blur(function () {
      //   that.searchs.but = true;
      //   that.searchs.sear = false;
      // })
      if(this.$route.name == 'webcase'){
        this.nav_id = 2
      }else if(this.$route.name == 'index'){
        this.nav_id = 1
      }else if(this.$route.name == 'about'){
        this.nav_id = 7
      }else if(this.$route.name == 'items'){
        this.nav_id = this.$route.params.id.split('.')[0]
      }
    },
    watch: {
      $route(to, from) {
      }
    },
    updated:function(){
           window.scroll(0, 0);
          },
  };
</script>
<!--<script>-->
<!--  var _hmt = _hmt || [];-->
<!--  (function() {-->
<!--    var hm = document.createElement("script");-->
<!--    hm.src = "https://hm.baidu.com/hm.js?b2379d0f69469913897489dec1b648db";-->
<!--    var s = document.getElementsByTagName("script")[0];-->
<!--    s.parentNode.insertBefore(hm, s);-->
<!--  })();-->
<!--</script>-->
<style scoped lang="less">
  .body_div{
    min-width: 1200px;
    width: 100%;
  }
  .nav {
    .top {
      width: 100%;
      background: #fff;
      position: fixed;
      z-index: 1000;
      border-top: 2px solid #e50012;
      overflow: hidden;
      height: 80px;
      box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.1);

      .w {
        padding: 10px 0px;

        .logo {
          width: 20%;
          margin-right: 120px;
          margin-top: auto !important;

          img {
            width: 230px;
          }
        }

        .menu {
          height: 57px;
          width: 70%;

          ul {
            display: flex;
            justify-content: space-between;

            li {
              text-align: center;
              flex: 1;
              font-size: 16px;
              line-height: 57px;

              a {
                padding-bottom: 20px;
                transition: all 0.3s;

              }

              a:hover {
                height: 100%;
                border-bottom: 3px solid #e50012;
                font-size: 18px;
                color: #e50012;
              }
            }

            .active {
              a {
                border-bottom: 3px solid #e50012;
                font-size: 18px;
                color: #e50012;
                transform: scale(1.1);
              }
            }
          }


          .input_div {
            height: 50px;
            margin-top: 3px;
            width: 65%;
            border: 1px solid #f2f2f2;
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;


            input {
              outline: none;
              height: 50px;
              line-height: 50px;
              width: 80%;
              font-size: 16px
            }
          }
        }
      }
    }

    .wrapper {
      height: auto !important;
      padding-top: 80px;

      .swiper-item img {
        width: 100%;
      }
    }
  }

  .footer {
    font-size: 14px;
    background: #212121;
    min-width: 1200px;
    width: 100%;
    color: #fff;
    padding: 50px 0px 0px;
    box-sizing: border-box;

    .chat {
      float: left;
      div {
              width: 110px;
              height: 35px;
              margin-bottom: 10px;
              border: 1px solid #fff;
              border-radius: 3px;
              line-height: 35px;
              box-sizing: border-box;

              a {
                color: #ffff;

                img {
                  width: 15px;
                  margin-right: 10px;
                }
              }
            }
    }
    .contact-us {
      margin-bottom: 20px;
            h4 {
              font-size: 14px;
              margin-bottom: 25px;
            }

            .contact-main {
              margin-bottom: 20px;

              img {
                max-width: 20px;
                margin-right: 15px;
              }
            }


          }

    .data {
      padding-bottom: 30px;

      .data-link {
        .data-fl{
          width: 60%;

          .about-us{
            margin-bottom: 20px;
          }

        }
        .data-fl > div {
          width: 100%;

          li {
            margin-bottom: 20px;
            font-size: 14px;
            float: left;
            margin-right: 20px;

            a {
              color: #fff;
            }
          }

          li:first-child {
            font-size: 14px;
          }
        }

        .data-fr {

          .wechat {
            margin-right: 30px;
            img {
              width: 100px;
              margin-bottom: 5px;
            }
            p {
              text-align: center;
              margin-top: 8px;

            }
          }
        }
      }
    }

    .information {
      background: #111;
      height: 50px;
      line-height: 50px;
      overflow: hidden;
    }

    .gotop {
      width: 50px;
      position: fixed;
      right: 10px;
      bottom: 10px;
      z-index: 10000;

      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/layout.vue